export type Builder = {
  name: string;
  slug: string;
  imageUrl: string;
  slackUrl: string;
};

export const builders: Builder[] = [
  {
    name: "Anthony",
    slug: "anthony",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U0311FJ929J-23f3458c6939-512",
    slackUrl: "https://pineparkhealth.slack.com/team/U0311FJ929J",
  },
  {
    name: "Ashley",
    slug: "ashley",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U018L1U5H24-8c03a4ed5939-512",
    slackUrl: "https://pineparkhealth.slack.com/team/U018L1U5H24",
  },
  {
    name: "Erin",
    slug: "erin",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U053NTTMN90-bfd13771f555-512",
    slackUrl: "https://pineparkhealth.slack.com/team/U053NTTMN90",
  },
  {
    name: "Genualdi",
    slug: "genualdi",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U07B4EYLJM7-4e6f47cc81cc-512",
    slackUrl: "https://pineparkhealth.slack.com/team/U07B4EYLJM7",
  },
  {
    name: "Katherine",
    slug: "katherine",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U05UV4CF7H9-dba3c8566366-512",
    slackUrl: "https://pineparkhealth.slack.com/archives/D060C8GGU4A",
  },
  {
    name: "Mike",
    slug: "mike",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U01B31HKQLE-a56d28d24d18-512",
    slackUrl: "https://pineparkhealth.slack.com/team/U01B31HKQLE",
  },
  {
    name: "Shane",
    slug: "shane",
    imageUrl: "https://ca.slack-edge.com/T01828ZU44C-U049LG1PW2U-6b04fdbbc495-512",
    slackUrl: "https://pineparkhealth.slack.com/archives/D048WN197TM",
  },
];
